import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import { useMsal } from "@azure/msal-react";
import { Typography, Box } from "@mui/material";
import { formatEmpty, formatCurrency } from "../../../../utils/formatHelpers";
import InfoIcon from "../../../../assets/icons/InfoIcon";
import PrimaryTextField from "../../../Inputs/PrimaryTextField/PrimaryTextField";
import StyledTooltip from "../../../StyledTooltip/StyledTooltip";
import SecurityCheck from "../../../SecurityCheck/SecurityCheck";
import { nullCheck } from "../../../../utils/dataHelpers";
import { CarrierService } from "../../../../services/CarrierService";
import { AlertContext } from "../../../Dashboard/Dashboard";

export default function MaxPayCell({ cell, row, column, updateData }) {
  const { instance } = useMsal();
  const { warning } = useContext(AlertContext);
  const datRateview = nullCheck(cell, null, "row", "original", "datRateview");
  const isRevenueAdjustment = nullCheck(
    cell,
    null,
    "row",
    "original",
    "isRevenueAdjustment"
  );
  const orderId = nullCheck(cell, null, "row", "original", "orderId");
  const movementId = nullCheck(cell, null, "row", "original", "movementId");
  const active = nullCheck(row, false, "original", "activeRow");
  const [maxPay, setMaxPay] = useState(cell.value);
  const [isLoading, setIsLoading] = useState(false);
  const [oldMaxPay, setOldMaxPay] = useState(cell.value);

  const handleUpdateMaxPay = () => {
    if (cell.value === maxPay) return;

    if (maxPay >= 100) {
      const payload = {
        orderId: orderId,
        movementId: `${movementId}`,
        overrideMaxPay: maxPay,
      };

      setOldMaxPay(maxPay);
      updateData(row.index, column.id, maxPay);

      setIsLoading(true);
      CarrierService.UpdateMaxPay(instance, payload)
        .catch((error) => {
          console.error(error);
          alert(`Load "${row.original.orderId}" Max Pay Update Failed"`);
          setMaxPay(oldMaxPay);
          updateData(row.index, column.id, oldMaxPay);
          warning(error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setMaxPay(cell.value ?? 0);
      alert("Error, Minimum 3-Digits required");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "end",
        alignItems: "center",
        marginTop: "-4px",
      }}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {isRevenueAdjustment && (
        <StyledTooltip
          title={`DAT: ${formatEmpty(formatCurrency(datRateview, 2))}`}
        >
          <Box sx={{ height: "20px", marginRight: "8px" }}>
            <InfoIcon
              sx={{
                fontSize: "20px",
                color: "error.60",
              }}
            />
          </Box>
        </StyledTooltip>
      )}
      <SecurityCheck
        componentName="CarrierOffersDashboardManager"
        action="Read"
      >
        <span style={{ display: "flex", paddingRight: "20px" }}>
          <PrimaryTextField
            value={maxPay}
            onChange={setMaxPay}
            onBlur={handleUpdateMaxPay}
            onEnter={handleUpdateMaxPay}
            isNumber
            isCurrency
            disabled={isLoading}
            error={!maxPay}
          />
        </span>
      </SecurityCheck>
      <SecurityCheck componentName="CarrierOffersDashboardRep" action="Read">
        <Typography
          variant="body1"
          sx={{
            color: active ? "white_opacity.100" : "black_solid.80",
          }}
        >
          {formatEmpty(formatCurrency(maxPay))}
        </Typography>
      </SecurityCheck>
    </Box>
  );
}

MaxPayCell.propTypes = {
  cell: PropTypes.object,
  row: PropTypes.object,
  column: PropTypes.object,
  updateData: PropTypes.func,
};
